import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
interface TestimonialProps {
  quote: string;
  author: string;
}
const TestimonialCard = ({
  quote,
  author
}: TestimonialProps) => <motion.div whileHover={{
  y: -5
}} className="bg-white p-8 rounded-xl border border-border shadow-sm" data-id="element-234">
    <div className="flex mb-4" data-id="element-235">
      {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-gold fill-gold" data-id="element-236" />)}
    </div>
    <p className="text-ink italic mb-6 text-base md:text-lg leading-relaxed" data-id="element-237">
      "{quote}"
    </p>
    <div data-id="element-238">
      <p className="font-bold text-ink font-serif" data-id="element-239">{author}</p>
    </div>
  </motion.div>;
export function TestimonialsFirstSet() {
  // Empty or minimal to not break App.tsx if still imported, but we will remove it from App.tsx rendering
  return null;
}
export function TestimonialsSecondSet() {
  const testimonials = [{
    quote: 'Tenía miedo de enfrentar casos de ARFID. Con el Radar ARFID Pro entendí todo en una tarde. En la siguiente sesión ya tenía un criterio claro para hablar con la familia.',
    author: 'Cecilia R. — Terapeuta Ocupacional, Mendoza'
  }, {
    quote: 'El Flash Planner me devolvió los domingos. Ya no paso 3 horas planificando. En 10 minutos tengo toda la semana organizada.',
    author: 'Roberto M. — Fonoaudiólogo, Buenos Aires'
  }, {
    quote: 'Llegaba a cada sesión de alimentación con angustia. Ahora tengo protocolos para cada nivel y mis familias ven avances reales. Cambió mi práctica clínica por completo.',
    author: 'Sofía C. — Terapeuta Ocupacional, La Plata'
  }, {
    quote: 'Nunca pensé que por $19.990 iba a tener un sistema tan completo. Lo amortizé en la primera semana de sesiones.',
    author: 'Luciana M. — Terapeuta Ocupacional, Córdoba'
  }];
  return <section className="bg-surface py-16 px-4 border-y border-border" data-id="element-240">
      <div className="max-w-6xl mx-auto" data-id="element-241">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-ink mb-12 font-serif" data-id="element-242">
          ❤️ LO QUE DICEN LAS TERAPEUTAS QUE YA LO TIENEN
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-243">
          {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-244" />)}
        </div>
      </div>
    </section>;
}